module.exports = __webpack_public_path__ + "img/全链条司法p2.78e3b2b2.png";